import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { EquipmentTireConfig, ListItem, RepositoryModal } from '../../shared'
import { TIRE_SIDES } from '../../field-tools/equipment-report/report-components/tire-report.model'
import { PartsFluidsEquipmentContext } from '../parts-fluids/parts-fluids-equipment-context'

@Component({
    templateUrl: './equipment-tire-config-modal.component.html',
    standalone: true,
    imports: [FormsModule, FaIconComponent, WjInputModule],
})
export class EquipmentTireConfigModalComponent extends RepositoryModal<EquipmentTireConfig> {
    sideOptions = TIRE_SIDES.concat([{ value: 'Both', label: 'Both sides' }]).map(s => new ListItem(s.value, s.label))
    equipmentOptions: ListItem<string>[] = []

    protected onInitialized() {
        const parent = this.editOptions.initializeParams as PartsFluidsEquipmentContext & { equipmentOptions?: ListItem<string>[] }
        this.equipmentOptions = parent?.equipmentOptions ?? []
    }

    get useEquipmentPicker() {
        return this.equipmentOptions.length > 0
    }

    protected onSave(resolveSave: (result?: any) => void, rejectSave: (reason?: any) => void) {
        super.onSave(
            result => {
                const parent = this.editOptions.initializeParams as PartsFluidsEquipmentContext
                parent?.refresh?.()
                resolveSave(result)
            },
            rejectSave,
        )
    }
}
